module.exports = "<router-outlet></router-outlet>\n<app-scroll-to-top></app-scroll-to-top>\n"